var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ramId)?_c('span',{class:'ram-viewer-button btn btn-sm btn-' + (_vm.primary ? 'primary' : 'secondary'),on:{"click":_vm.navigate}},[_c('icon',{staticClass:"viewer-icon",attrs:{"name":_vm.icon}}),_c('span',[_vm._v(_vm._s(_vm.buttonText))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }